import { UIBurgerMenuButton } from '@headless-workspace/core-ui';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { Logo } from './Logo';

type HeaderMenuLogoProps = PropsWithLocale & {
    isH1Logo: boolean;
    burgerMenuAriaLabel: string;
};

export const HeaderBurgerMenuLogo: Component<HeaderMenuLogoProps> = ({ isH1Logo, burgerMenuAriaLabel, locale }) => {
    return (
        <div className={'flex flex-row items-center justify-center gap-0.5'}>
            <UIBurgerMenuButton ariaLabel={burgerMenuAriaLabel} />
            <Logo isH1Logo={isH1Logo} locale={locale} />
        </div>
    );
};
